module.exports = __webpack_public_path__ + "img/wcrun.d6b67461.jpg";